import { LoadMore } from "@jti/ui/components/LoadMore";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { trackCtaClick } from "../../utils/trackCtaClick";

export interface LoadMoreProps {
  onClick: () => void;
  state: boolean;
  dataTestId?: string;
}

const LoadMoreLoyalty = ({ onClick, state, dataTestId }: LoadMoreProps) => {
  const { __ } = useTranslations();
  const handleOnClick = () => {
    onClick();
    trackCtaClick(state ? "load-less" : "load-more", "LoadMoreCTA");
  };
  return (
    <LoadMore
      onClick={handleOnClick}
      label={state ? __("loyalty.load.less.label") : __("loyalty.load.more.label")}
      data-testid={dataTestId}
      expanded={state}
    />
  );
};

export default LoadMoreLoyalty;
